import { Box } from "@mui/material";
import { DotLegalDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import PolicyControlChip from "../../policy/policySections/PolicyControlChip/PolicyControlChip";
import { resolveControls } from "../../policy/policySections/PolicySections.utils";
import { useSelectableControlsForRisk } from "./RiskControls.hooks";

export interface LinkedControlsDialogProps {
    linkedControlIds: Array<string>;
    onClose: () => void;
}

// Read-only view of an entity's / scenario's linked framework controls, opened from the clickable count cell.
// Reuses the existing control chips (customId + name link to the control + its status chip); no add/remove here,
// so links are managed only from the assess dialog.
function LinkedControlsDialog({ linkedControlIds, onClose }: LinkedControlsDialogProps) {
    const { translateString } = useTranslation();
    const controlsQuery = useSelectableControlsForRisk();
    const controls = resolveControls(linkedControlIds, controlsQuery.data ?? []);

    return (
        <DotLegalDialog
            open
            size="md"
            header={translateString("linkedControls")}
            buttonOkText={translateString("close")}
            onOkClick={onClose}
            onDialogClose={onClose}
            isLoading={controlsQuery.isLoading}
        >
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {controls.map((control) => (
                    <PolicyControlChip key={control.id} control={control} />
                ))}
            </Box>
        </DotLegalDialog>
    );
}

export default LinkedControlsDialog;
